import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const zonesResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getZones();
        to.meta.zones = res.data.data;
    } catch(error) {
        console.error('CENTER_RESOLVER_ERROR');
        return { name: 'Zones' };
    }
}